/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ContractDirectModeResource } from './';
import {
    ContractDirectModeResourceFromJSON,
    ContractDirectModeResourceFromJSONTyped,
    ContractDirectModeResourceToJSON,
} from './';
import type { ContractSubcontractingModeResource } from './';
import {
    ContractSubcontractingModeResourceFromJSON,
    ContractSubcontractingModeResourceFromJSONTyped,
    ContractSubcontractingModeResourceToJSON,
} from './';
import type { ContractTripartiteModeResource } from './';
import {
    ContractTripartiteModeResourceFromJSON,
    ContractTripartiteModeResourceFromJSONTyped,
    ContractTripartiteModeResourceToJSON,
} from './';
import type { InvoicingMode } from './';
import {
    InvoicingModeFromJSON,
    InvoicingModeFromJSONTyped,
    InvoicingModeToJSON,
} from './';

/**
 * 
 * @export
 * @interface ContractInvoicingModeResource
 */
export interface ContractInvoicingModeResource {
    /**
     * 
     * @type {InvoicingMode}
     * @memberof ContractInvoicingModeResource
     */
    type: InvoicingMode;
}

/**
 * Check if a given object implements the ContractInvoicingModeResource interface.
 */
export function instanceOfContractInvoicingModeResource(value: object): value is ContractInvoicingModeResource {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function ContractInvoicingModeResourceFromJSON(json: any): ContractInvoicingModeResource {
    return ContractInvoicingModeResourceFromJSONTyped(json, false);
}

export function ContractInvoicingModeResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractInvoicingModeResource {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['type'] === 'DIRECT') {
            return ContractDirectModeResourceFromJSONTyped(json, true);
        }
        if (json['type'] === 'SUBCONTRACTING') {
            return ContractSubcontractingModeResourceFromJSONTyped(json, true);
        }
        if (json['type'] === 'TRIPARTITE') {
            return ContractTripartiteModeResourceFromJSONTyped(json, true);
        }
    }
    return {
        
        'type': InvoicingModeFromJSON(json['type']),
    };
}

export function ContractInvoicingModeResourceToJSON(value?: ContractInvoicingModeResource | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
        if (value.type === 'DIRECT') {
            return ContractDirectModeResourceToJSON(value as ContractDirectModeResource);
        }
        if (value.type === 'SUBCONTRACTING') {
            return ContractSubcontractingModeResourceToJSON(value as ContractSubcontractingModeResource);
        }
        if (value.type === 'TRIPARTITE') {
            return ContractTripartiteModeResourceToJSON(value as ContractTripartiteModeResource);
        }
    }
    return {
        
        'type': InvoicingModeToJSON(value['type']),
    };
}

